import { baseEnvironmentProd } from 'src/environments/baseEnvironment.prod';

export const environment = {
  ...baseEnvironmentProd,
  organizationPrefix: '4DS',
  organizationUUID: '18f270e1-c148-416c-8d85-455410e2fa37',
  activeLanguage: 'it-IT',
};
